import { ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLocation } from 'wouter';
import { usePipelineContext } from '../../context';
import type { Customer } from '../../types';

interface PipelineCardActionsProps {
  customer: Customer;
}

/**
 * Action buttons for expanded pipeline cards
 * Includes View Details and OpenSolar integration buttons
 */
export function PipelineCardActions({ customer }: PipelineCardActionsProps) {
  const [, setLocation] = useLocation();
  const { actions } = usePipelineContext();

  return (
    <div className="flex gap-2 pt-3 mt-2 border-t border-slate-100 dark:border-slate-700/60 flex-shrink-0">
      <Button
        variant="outline"
        size="sm"
        className="h-8 text-xs w-full"
        onClick={(e) => {
          e.stopPropagation();
          // Direct to customer master view page
          setLocation(`/customers/${customer.id}`);
        }}
      >
        View Details
      </Button>

      <Button
        variant="outline"
        size="sm"
        className="h-8 text-xs w-full"
        onClick={(e) => {
          e.stopPropagation();
          actions.createOpenSolarProject(customer.id);
        }}
      >
        <ExternalLink className="mr-1 h-3 w-3" />
        OpenSolar
      </Button>
    </div>
  );
}
